// Build-time constants for the staging build (project.json's `staging` configuration
// replaces environment.ts with this file). Identical to environment.prod.ts on purpose:
// everything that differs per environment is served at runtime as SERVER_CONFIG from
// /env.config.js, generated per hostname from config/<tier>/hosts/<hostname>/env.config.js.
export const environment = {
  production: false,
  test: false,
  web: true,
  isCB: false,
  sentryUrl: null,
  sentryShowDialog: false,
  imageServer: 'https://d20xk4sxen1bs2.cloudfront.net',
  includeLegs: true,
  haveCommunicationHander: false,
  allEndpointsWithCredentials: false,
  xpointKey: null,
  core: {
    customSessionExpireRedirect: false,
    trackingPageTitle: 'MATCHBOOK'
  }
};
